import './styles/main.css';
import { LogicTeachingApp } from './app/LogicTeachingApp';

const host = document.querySelector<HTMLElement>('#app');
if (!host) throw new Error('Missing #app root element');

const app = new LogicTeachingApp(host);
void app.start();
